import ExpandedText from './expanded_text';

export default (ExpandedText);
